<template>
  <v-layout wrap justify-center>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar
      :timeout="3000"
      :value="true"
      right
      color="red"
      v-model="showsnackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
    <v-flex xs12 lg11 pt-6>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card
            class="mx-auto elevation-1 pa-6"
            max-width="1088px"
            align="center"
            outlined
          >
            <v-layout wrap justify-space-between>
              <v-flex
                xs12
                sm6
                pb-2
                pb-md-0
                class="text-left nsbold"
                style="font-weight: 700; font-size: 20px"
                >School Bus
              </v-flex>
              <!-- <v-flex
                xs12
                sm3
                md4
                lg4
                pb-2
                pb-md-0
                align-self-center
                class="text-left nsregular"
              >
                <v-text-field
                  v-model="keyword"
                  dense
                  class="rounded-xl"
                  label="Search"
                  outlined
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex> -->
              <v-flex
                xs12
                sm3
                md2
                pb-2
                pb-md-0
                align-self-center
                class="text-left nsregular"
              >
                <v-dialog max-width="70%" v-model="addDialog">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      width="100px"
                      dark
                      block
                      v-bind="attrs"
                      v-on="on"
                      color="#766BC0"
                      class="rounded-lg"
                    >
                      <v-icon x-small>mdi-plus</v-icon>
                      <span
                        class="text-left nsregular"
                        style="font-weight: 400; font-size: 12px"
                        >Add School Bus</span
                      ></v-btn
                    >
                  </template>

                  <v-card>
                    <v-toolbar dark color="#766BC0" dense flat class="body-2">
                      <v-toolbar-title> Add Details </v-toolbar-title>
                    </v-toolbar>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap pa-4>
                        <v-flex xs12 sm6 align-self-center pa-2>
                          <v-text-field
                            dense
                            hide-details
                            outlined
                            required
                            label="Bus Name"
                            v-model="busData.name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 align-self-center pa-2>
                          <v-text-field
                            dense
                            required
                            hide-details
                            outlined
                            label="Bus Number"
                            v-model="busData.busNumber"
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 align-self-center pa-2>
                          <v-text-field
                            dense
                            hide-details
                            outlined
                            required
                            label="Bus Registration Number"
                            v-model="busData.plateNumber"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 align-self-center pa-2>
                          <v-select
                            dense
                            hide-details
                            outlined
                            required
                            :items="['Bus', 'Traveller', 'Van']"
                            label="Vehicle Type"
                            v-model="busData.vehicleType"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 align-self-center pa-2>
                          <v-text-field
                            dense
                            hide-details
                            outlined
                            required
                            label="Capacity"
                            v-model="busData.capacity"
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 align-self-center pa-2>
                          <v-text-field
                            dense
                            hide-details
                            outlined
                            required
                            label="Phone Number"
                            v-model="busData.phone"
                            :rules="rules.phoneRules"
                            :counter="10"
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 align-self-center pa-2>
                          <v-text-field
                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show2 ? 'text' : 'password'"
                            @click:append="show2 = !show2"
                            dense
                            hide-details
                            outlined
                            required
                            label="Password"
                            v-model="busData.password"
                            :rules="rules.required"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-card-actions class="pt-3">
                        <v-spacer></v-spacer>
                        <v-btn
                          color="grey"
                          text
                          class="body-2 font-weight-bold"
                          @click="addDialog = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          :disabled="!valid"
                          color="#766BC0"
                          class="body-2 font-weight-bold"
                          outlined
                          @click="validateInput()"
                          >OK</v-btn
                        >
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Bus Name</th>
                        <!-- <th class="text-left">Trip Details</th> -->
                        <th class="text-left">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="text-left regular"
                        v-for="(item, i) in sectionList"
                        :key="i"
                      >
                        <td>{{ item.name }}</td>
                        <!-- <td>
                          <v-layout wrap>
                            <v-flex xs6 align-self-center v-if="item">
                              <v-btn
                                :to="
                                  '/viewBusStops?id=' +
                                  item._id +
                                  '&tname=' +
                                  item.name
                                "
                                small
                                class="text-none nsregular"
                                color="#766BC0"
                                dark
                                tile
                                depressed
                              >
                                <span>View Details</span>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </td> -->
                        <td>
                          <v-layout wrap>
                            <v-flex xs6 sm3 align-self-center v-if="item">
                              <v-btn
                                :to="
                                  '/viewBusTrips?id=' +
                                  item._id +
                                  '&tname=' +
                                  item.name
                                "
                                small
                                class="text-none nsregular"
                                icon
                                title="View Trip details"
                                tile
                                depressed
                              >
                                <v-icon>mdi-eye</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex xs6 sm3 align-self-center v-if="item">
                              <span
                                ><v-icon
                                  style="cursor: pointer"
                                  @click="editCurrent(item)"
                                  >mdi-circle-edit-outline</v-icon
                                ></span
                              >
                            </v-flex>
                            <!-- <v-flex xs6 align-self-center>
                              <span
                                ><v-icon
                                  style="cursor: pointer"
                                  @click="(dialoge = true), (curId = item._id)"
                                  >mdi-delete-outline</v-icon
                                ></span
                              >
                            </v-flex> -->
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog width="450px" v-model="dialoge">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Confirm Delete </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"
            >Are you sure you want to delete this record?
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialoge = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="deleteBus()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="70%" v-model="editdialogue">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Edit Details </v-toolbar-title>
          </v-toolbar>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap pa-4>
              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  dense
                  hide-details
                  outlined
                  required
                  label="Bus Name"
                  v-model="curItem.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  dense
                  required
                  hide-details
                  outlined
                  label="Bus Number"
                  v-model="curItem.busNumber"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  dense
                  hide-details
                  outlined
                  required
                  label="Bus Registration Number"
                  v-model="curItem.plateNumber"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center pa-2>
                <v-select
                  dense
                  hide-details
                  outlined
                  required
                  :items="['Bus', 'Traveller', 'Van']"
                  label="Vehicle Type"
                  v-model="curItem.vehicleType"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  dense
                  hide-details
                  outlined
                  required
                  label="Capacity"
                  v-model="curItem.capacity"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  dense
                  hide-details
                  outlined
                  required
                  label="Phone Number"
                  v-model="curItem.phone"
                  :rules="rules.phoneRules"
                  :counter="10"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  dense
                  hide-details
                  outlined
                  required
                  label="Create New Password"
                  placeholder="Create New Password"
                  v-model="curItem.password"
                  :rules="rules.required"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-card-actions class="pt-3">
              <v-spacer></v-spacer>
              <v-btn
                color="grey"
                text
                class="body-2 font-weight-bold"
                @click="editdialogue = false"
                >Cancel</v-btn
              >
              <v-btn
                :disabled="!valid"
                color="#766BC0"
                class="body-2 font-weight-bold"
                outlined
                @click="editBus()"
                >OK</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-layout wrap>
        <v-flex xs12 pt-4>
          <v-pagination
            small
            color="#766BC0"
            v-model="page"
            :length="Pagelength"
          >
          </v-pagination>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      page: 1,
      Pagelength: 0,
      dialoge: false,
      editdialogue: false,
      showsnackbar: false,
      msg: null,
      appLoading: false,
      ServerError: false,
      valid: true,
      sectionData: {},
      curItem: {},
      sectionList: null,
      busData: {},
      show2: true,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      doManual: false,
      addDialog: false,
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
    // keyword() {
    //   this.getData();
    // },
  },
  methods: {
    editCurrent(item) {
      this.curItem = item;
      if (item.userid) {
        this.curItem.phone = item.userid.phone;
      }

      this.editdialogue = true;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          // keyword: this.keyword,
          page: this.page,
          limit: 20,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.sectionList = response.data.data;
            this.Pagelength = Math.ceil(response.data.totalLength / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
            this.ServerError = true;
          console.log(err);
        });
    },
    //delete button
    deleteBus() {
      axios({
        url: "/admin/bus/remove/",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.curId,
        },
      })
        .then((response) => {
          this.delete = false;
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            // this.$router.go(-1)
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    validateInput() {
      if (
        !this.busData.name ||
        !this.busData.phone ||
        !this.busData.busNumber ||
        !this.busData.plateNumber ||
        !this.busData.vehicleType ||
        !this.busData.capacity ||
        !this.busData.password
      ) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else this.addBus();
    },
    //add button
    addBus() {
      {
        this.appLoading = true;
        axios({
          url: "/admin/bus/add",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.busData,
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.addDialog = false;
              this.msg = response.data.msg;
              this.showsnackbar = true;

              this.$refs.form.reset();
              this.$refs.form.resetValidation();
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }

            this.getData();
            this.busData = {};
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    //edit button
    editBus() {
      if (
        !this.curItem.name ||
        !this.curItem.phone ||
        !this.curItem.busNumber ||
        !this.curItem.plateNumber ||
        !this.curItem.vehicleType ||
        !this.curItem.capacity
      ) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else {
        axios({
          url: "/admin/bus/edit",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.curItem,
        })
          .then((response) => {
            this.editdialogue = false;
            this.appLoading = false;
            if (response.data.status) {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
            this.getData();
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
#map44 {
  height: 100%;
}
</style>
